<template>
  <div>
    <wc-data-box
      :title='storePath.title'
      :titleIcon='storePath.icon'
      :titleIconColor='storePath.iconColor'
      showEdit
      @edit='openEdit'
      :loading='isLoading'
    >
      <v-simple-table dense>
        <tbody>
          <tr>
            <td :class='label'>Division</td>
            <td :class='dataValue'>
              <wc-division-nai :division_obj='item.division_obj'/>
            </td>
          </tr>
          <tr>
            <td :class='label'>Service Price</td>
            <td :class='dataValue'>{{ item.service_price | decMoney }}</td>
          </tr>
          <tr>
            <td :class='label'>Company Cost</td>
            <td :class='dataValue'>{{ item.company_cost | decMoney }}</td>
          </tr>
          <!--
           <tr>
            <td :class='label'>Is Estimate Only</td>
            <td :class='dataValue'>{{ item.is_estimate_only | trueFalse }}</td>
          </tr>
          <tr v-if='item.is_small_radius_head'>
            <td :class='label'>
              This is a small radius head.
            </td>
            <td align='right'>
              <v-icon color='success darken-1'>mdi-sprinkler</v-icon>
            </td>
          </tr>
          <tr v-if='item.is_large_radius_head'>
            <td :class='label'>
              This is a large radius head.
            </td>
            <td align='right'>
              <v-icon color='success darken-1'>mdi-sprinkler-variant</v-icon>
            </td>
          </tr>
          -->
        </tbody>
      </v-simple-table>
    </wc-data-box>
<!-- edit dialog box below  -->
     <wc-dialog
      :showDialog='showDialog'
      title='Edit Details'
      :icon='storePath.icon'
      :iconColor='storePath.iconColor'
      width='450'
      @cancel='cancelEdit'
      @save='saveEdit'
      :loading='isLoading'
      :disableButtons='!isFormValid'
    >
      <v-form v-model="isFormValid" ref='form'>
<!-- do we allow edit for the division to happen here? or is this set at creation? -->
        <v-select
          label='Division'
          :items='divisions'
          item-value='id'
          item-text='division'
          v-model='itemCopy.division'
        ></v-select>
        <v-row dense>
          <!-- Removed per discussion with office - May 7, 2021 - EM
          <v-col>
            <v-text-field
              label='Estimate Price'
              :rules='[rules.decimal]'
              prepend-icon='mdi-currency-usd'
              reverse
              v-model='itemCopy.estimate_price'
            ></v-text-field>
          </v-col>
          -->
          <v-col>
            <v-text-field
              label='Service Price'
              :rules='[rules.decimalOrEmpty]'
              prepend-icon='mdi-currency-usd'
              reverse
              v-model='itemCopy.service_price'
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label='Company Cost'
              :rules='[rules.decimalOrEmpty]'
              prepend-icon='mdi-currency-usd'
              reverse
              v-model='itemCopy.company_cost'
            ></v-text-field>
          </v-col>
        </v-row>
        <!--
        <v-checkbox
          label='Estimate Only?'
          v-model='itemCopy.is_estimate_only'
        ></v-checkbox>
        <v-checkbox
          label='Is this a small radius head?'
          hint='Used for estimating purposes (1800s, etc)'
          persistent-hint
          @change='srhClicked'
          v-model='itemCopy.is_small_radius_head'
        ></v-checkbox>
        <v-checkbox
          label='Is this a large radius head?'
          hint='Used for estimating purposes (3500s, 5000s, etc)'
          persistent-hint
          @change='lrhClicked'
          v-model='itemCopy.is_large_radius_head'
        ></v-checkbox>
        -->
      </v-form>
    </wc-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'
export default {
  name: 'inventory-details',
  props: {
    item: {
      required: true
    }
  },
  mixins: [formRules],
  data: () => ({
    isLoading: false,
    isFormValid: false,
    label: 'grey--text',
    dataValue: 'text-right',
    showDialog: false,
    icon: null,
    iconColor: null,
    itemCopy: {}
  }),
  computed:{
    storePath () { return this.$store.state.icons.dataBox.details },
    divisions () { return this.$store.state.misc.divisions }
  },
  methods: {
    openEdit () {
      this.itemCopy = _.cloneDeep(this.item)
      this.showDialog = true
    },
    cancelEdit () {
      this.showDialog = false
    },
    saveEdit () {
      this.isLoading = true
      this.$emit('update', this.itemCopy)
      this.showDialog = false
      this.isLoading = false
    },
    srhClicked () {
      // If the small radius head option is set to TRUE, we deselect the large radius head
      if (this.itemCopy.is_small_radius_head) {
        this.itemCopy.is_large_radius_head = false
      }
    },
    lrhClicked () {
      // If the large radius head option is set to TRUE, we deselect the small radius head
      if (this.itemCopy.is_large_radius_head) {
        this.itemCopy.is_small_radius_head = false
      }
    }
  }
}
</script>